module.exports = __webpack_public_path__ + "img/an_bg.8b193a26.jpg";